import Api from '../decorators/Api';
import HttpService from './HttpService';
import Activation from '../models/Activation';
import CompanyListItem from '../models/CompanyListItem';
import SearchParams from '../models/SearchParams';
import { Pagination } from '../utils/Pagination';
import SearchResult from '../models/SearchResult';
import CompanyModel from '../models/CompanyModel';
import CompanyWorkspaceSettings from '../models/CompanyWorkspaceSettings';
import CompanyAccount from '../models/CompanyAccount';

@Api(`${process.env.VUE_APP_OPERATION_API_URI}/companies`)
export class CompanyService extends HttpService {
  public async list(params?: SearchParams): Promise<CompanyListItem[]> {
    return (await this.get<CompanyListItem[]>('/', { params })).data;
  }
  public async search(params?: SearchParams): Promise<SearchResult<CompanyListItem>> {
    params = params || new SearchParams();
    const response = await this.get<CompanyListItem[]>('/', { params });
    const pagination = new Pagination(response.headers, params.limit!, params.offset!);
    return new SearchResult<CompanyListItem>(response.data!, pagination);
  }
  public async listActivationsByCompanyId(companyId: string): Promise<Activation[]> {
    return (await this.get<Activation[]>(`${companyId}/activations`)).data;
  }
  public async create(company: CompanyModel): Promise<{ Id: string }> {
    return (await this.post<{ Id: string }>('/', company)).data;
  }
  public async update(id: string, company: CompanyModel): Promise<void> {
    await this.put(`/${id}`, company);
  }
  public async getById(id: string): Promise<CompanyModel> {
    return (await this.get<CompanyModel>(`/${id}`)).data;
  }
  public async getWorkspaceSettings(id: string): Promise<CompanyWorkspaceSettings> {
    return (await this.get<CompanyWorkspaceSettings>(`/${id}/Settings/Workspace`)).data;
  }
  public async setWorkspaceSettings(id: string, settings: CompanyWorkspaceSettings): Promise<void> {
    await this.post<CompanyModel>(`/${id}/Settings/Workspace`, settings);
  }
  public async updateWorkspaceSettings(id: string, settings: CompanyWorkspaceSettings): Promise<void> {
    await this.put<CompanyModel>(`/${id}/Settings/Workspace`, settings);
  }
  public async listAccounts(id: string): Promise<CompanyAccount[]> {
    return (await this.get(`/${id}/accounts`)).data;
  }
}

export default new CompanyService();
